<template>
    <div>
        <b-tab>
            <!-- <b-tab :lazy="tabLazy" @click="tabLazy = false"> -->
            <template #title>
                {{ $t('actions.types.MethodeOPCUA') }}
                <font-awesome-icon icon="fa fa-warning" class="ml-1 text-danger" v-if="invalidState" />
            </template>
            <b-card>
                <b-form>
                    <b-form-group :label="$t('actions.MethodeOPCUA.NodeId')" label-for="NodeId">
                        <b-form-input
                            id="NodeId"
                            v-model="configNodeId"
                            :class="{'disabled': !$store.state.auth.user.permissions.PermissionWrite}"
                        />
                    </b-form-group>
                    <b-form-group :label="$t('actions.MethodeOPCUA.MethodId')" label-for="MethodId">
                        <b-form-input
                            id="MethodId"
                            v-model="configMethodId"
                            :class="{'disabled': !$store.state.auth.user.permissions.PermissionWrite}"
                        />                    
                    </b-form-group>
                    <b-row>
                        <b-col>
                            <label for="inputsTable" v-text="$t('actions.MethodeOPCUA.inputsOutputs')" />
                            <DxDataGrid
                                id="inputsOutputsTable"
                                :dataSource="items"
                                :allow-column-reordering="true"
                                :repaint-changes-only="true"
                                :show-borders="true"
                                :selection="{ mode: 'single' }"
                                :columnAutoWidth="true"
                                :allow-column-resizing="true"
                                @init-new-row="onRowInserting"
                                @row-updating="onItemValueChanged"
                                @editing-start="onEditingStart"
                            >
                                <DxEditing
                                    :allow-updating="$store.state.auth.user.permissions.PermissionWrite"
                                    :allow-adding="$store.state.auth.user.permissions.PermissionWrite"
                                    :allow-deleting="$store.state.auth.user.permissions.PermissionWrite"
                                    :use-icons="true"
                                    mode="row"
                                />
                                <DxColumn data-field="Name" data-type="string" :allow-editing="true" :caption="$t('actions.MethodeOPCUA.name')" alignment="left" />
                                <DxColumn data-field="Type" data-type="string" :allow-editing="true" :caption="$t('actions.MethodeOPCUA.type')" alignment="left" :lookup="typeLookupConfig" />
                                <DxColumn
                                    data-field="Direction"
                                    data-type="string"
                                    :allow-editing="true"
                                    :caption="$t('actions.MethodeOPCUA.direction')"
                                    alignment="left"
                                    :lookup="directionLookupConfig"
                                />
                                <DxColumn data-field="Group" data-type="string" :allow-editing="true" :caption="$t('Group')" :set-cell-value="onGroupValueChanged" alignment="left">
                                    <DxLookup :data-source="equipmentGroups" />
                                </DxColumn>
                                <DxColumn data-field="Item" data-type="string" :allow-editing="true" :caption="$t('Item')" alignment="left">
                                    <DxLookup :data-source="currentGroupItems" />
                                </DxColumn>
                                <DxColumn
                                    data-field="Order"
                                    data-type="integer"
                                    :allow-editing="true"
                                    :caption="$t('Order')"
                                    alignment="left"
                                />
                          
                            </DxDataGrid>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-tab>
    </div>
</template>

<script>
import ToastAlert from '@/utils/ToastAlert';
import TreeView from '@/components/TreeView.vue';
import ProdComEquipmentService from '@/services/prodcom.equipments.service.js';
import { uuid } from 'vue-uuid';
import { DxDataGrid, DxColumn, DxLookup, DxEditing } from 'devextreme-vue/data-grid';
export default {
    name: 'MethodeOPCUA',
    props: {
        /**
         * Action object from parent component. Contains the equipment concerned,
         * and details about the action if opening an existing action.
         */
        action: Object,
        /**
         * Current project's Guid
         */
        propProject: String,
    },
    components: {
        ToastAlert,
        TreeView,
        DxDataGrid,
        DxColumn,
        DxLookup,
        DxEditing,
    },
    data() {
        return {
            items : [] ,
            dataValueFormat : [],
            equipmentGroups: [],
            equipmentItems: [],
            tabLazy: true,
            editor: null,
            availableGroups: [],
            availableDestinationItems: [],
            currentGroupItems: [],
            NodeId: '',
            MethodId: '',
            arguments: [],
            availableTypes: [
                { value: 'System.String', text: 'System.String' },
                { value: 'System.Int16', text: 'System.Int16' },
                { value: 'System.UInt16', text: 'System.UInt16' },
                { value: 'System.Int32', text: 'System.Int32' },
                { value: 'System.UInt32', text: 'System.UInt32' },
                { value: 'System.Int64', text: 'System.Int64' },
                { value: 'System.UInt64', text: 'System.UInt64' },
                { value: 'System.Float', text: 'System.Float' },
                { value: 'System.Double', text: 'System.Double' },
                { value: 'System.Boolean', text: 'System.Boolean' },
                { value: 'System.DateTime', text: 'System.DateTime' }
           
            ],
  
        };
    },
    computed: {
        invalidState() {
            return this.configNodeId == '' || this.configMethodId == '';
        },
        typeLookupConfig() {
            return {
                dataSource: this.availableTypes,
                valueExpr: 'value',
                displayExpr: 'text',
            };
        },
        directionLookupConfig() {
            return {
                dataSource: [
                    { value: 'IN', text: "IN" },
                    { value: 'OUT', text: "OUT"},
                ],
                valueExpr: 'value',
                displayExpr: 'text',
            };
        },
        configNodeId: {
            get() {
                const c = this.action && this.action.ActionConfiguration;
                return (c && c.NodeId) || '';
            },
            set(v) {
                this.ensureActionConfiguration();
                this.$set(this.action.ActionConfiguration, 'NodeId', v);
            },
        },
        configMethodId: {
            get() {
                const c = this.action && this.action.ActionConfiguration;
                return (c && c.MethodId) || '';
            },
            set(v) {
                this.ensureActionConfiguration();
                this.$set(this.action.ActionConfiguration, 'MethodId', v);
            },
        },
    },
    async mounted() {
        this.ensureActionConfiguration();


        var data = await ProdComEquipmentService.getGroups(this.action.Equipment, this.propProject);
        //let myVariablesColors = new Array();
        if (data.success == 'n') this.$EventBus.$emit('show-toast', new ToastAlert(this.$t(data.ret), 'warning'));
        else {
            this.equipmentGroups = data.ret.List;
        }

        await this.getEquipmentItems();


        // If action already has some data, set them.
        if (this.action.ActionConfiguration != null && this.action.ActionConfiguration.Arguments != null) {
            // Set variables
            for (var it of this.action.ActionConfiguration.Arguments) {
                this.items.push({ Name: it.Name, Type: it.Type, Direction: it.Direction, Group: it.Group, Item: it.Item, Order: it.Order });
            }
        }
    },
    methods: {
        ensureActionConfiguration() {
            if (!this.action) return;
            if (!this.action.ActionConfiguration) {
                this.$set(this.action, 'ActionConfiguration',
                {
                    Arguments: [],
                    NodeId: '',
                    MethodId: '',
                });
            }
        },
        async getEquipmentItems() {
            // get all equipment's variable (could not get the DevExtreme component to dynamically query this on value change...)
            this.equipmentItems = [];
            for (var grp of this.equipmentGroups) {
                var result = await ProdComEquipmentService.getItems(this.action.Equipment, grp, this.propProject);
                if (result.success == 'n') this.$EventBus.$emit('show-toast', new ToastAlert(this.$t(result.ret, result.retParams), 'warning'));
                else {
                    for (const [key, val] of Object.entries(result.ret.List)) {
                        this.equipmentItems.push({ group: grp, item: val.Name, value: val });
                    }
                }
            }
        },
        getEquipmentItemsForCurrentGroup(group) {
            this.currentGroupItems = this.equipmentItems.filter((it) => it.group === group).map((it) => it.item);
        },
        /**
         * Called by parent when validating the configuration.
         * Needs to return the current configuration of the action.
         */
        async validate() {
            console.log(this);
            if (this.invalidState) return null;
            var result = {
                NodeId: this.configNodeId,
                MethodId: this.configMethodId,
                Arguments: this.items.map(item => ({
                    Name: item.Name,
                    Type: item.Type,
                    Direction: item.Direction,
                    Group: item.Group,
                    Item: item.Item,
                    Order: item.Order,
                })),
            };
            console.log(result);
            return result;
        },
        /**
         * Query server for list of variables when group has changed
         */
         async destinationGroupChanged(e) {
            const result = await ProdComEquipmentService.getItems(this.action.Equipment, this.destinationGroup, this.propProject);
            if (result.success == 'n') this.$EventBus.$emit('show-toast', new ToastAlert(this.$t(result.ret, result.retParams), 'warning'));
            else {
                this.availableDestinationItems = [];
                for (const [key, val] of Object.entries(result.ret.List)) {
                    this.availableDestinationItems.push(val.Name);
                }
            }
        },
         onRowInserting(e) {
            var firstVariableNonExistant = this.equipmentItems.filter((x) => !this.items.find((y) => y.Group == x.group && y.Item == x.item))?.[0];
            if (firstVariableNonExistant != null) {
                e.data.Group = firstVariableNonExistant.group;
                e.data.Item = firstVariableNonExistant.item;
                e.data.TableField = "root";
            }
            this.getEquipmentItemsForCurrentGroup(e.data.Group);
            e.data.Item = e.data.Item ?? this.currentGroupItems[0];
        },
        // Warning: on this event, make sure to unfocus Group cell before selecting Item cell. Otherwise, the event won't be called.
        // TODO: fix this behaviour.
        onItemValueChanged(e) {
            if (e.newData.Item == null) return; // Make sure we only set TableField when Item is modified, not with other columns.
        },
        onGroupValueChanged(newData, value, currentRowData) {
            newData.Group = value;
            if (value == null) {
                newData.Item;
                return; // Make sure we only set Item when Group is modified, not with other columns.
            }
            this.getEquipmentItemsForCurrentGroup(value);
            if (this.currentGroupItems.length > 0) newData.Item = this.currentGroupItems[0];
        },
        onEditingStart(e) {
            this.getEquipmentItemsForCurrentGroup(e.data.Group);
        },
    },
};
</script>
<style lang="scss">
.highlight-blue {
    background-color: blue;
    color: white;
}
</style>